(function () {
    'use strict';


    angular.module('swif.framework')
    .factory('swifFormUtility', swifFormUtility);

    /**
    * @description provide infrastructure to create input & widget directive
    * @ngdoc service
    * @name swif.framework.swifFormUtility
    * @requires swif.framework.swifMomentUtility
    **/
    function swifFormUtility(swifMomentUtility, $timeout, swifModule) {
        'ngInject';
        // @NOTE: i set terminal to true o re-compile the whole generated DOM,
        // to handle DOM manipulations
        var service = {
            DEFAULT_WIDGET_DIRECTIVE: {
                restrict: 'E',
                replace: true,
                transclude: true,
                require: 'ngModel',
                terminal: true,
                scope: {
                    ngRequired: '<?',
                    ngDisabled: '<?',
                    standalone: '<',
                    helpText: '@?',
                    inputCol: '<?',
                    inputId: '@?',
                    swifChange: '&?',
                    swifPlaceholder: '@?'
                }
            },
            watchNgRequired: function (scope, element) {
                scope.$watch('ngRequired', function (newV) {
                    if (newV === true) {
                        element.addClass('required');
                    } else if (newV === false) {
                        element.removeClass('required');
                    }
                });
            },
            _findDomTag: function (element) {
                var ret = element.find('input');
                if(!ret || ret.length <= 0) {
                    ret = element.find('textarea');
                }
                return ret;
            },

            setNameAttrFromNgModel: function (scope, element, attr) {
                if (scope.name === undefined) {
                    scope.name = attr.ngModel;
                    this._findDomTag(element).attr('name', scope.name);
                }
            },
            watchIdToInput: function (scope, input) {
                scope.$watch('inputId', function (newV, oldV) {
                    if (newV !== input.prop('id')) {
                        input.prop('id', newV);
                    }
                });
            },
            copyAttributesToInput: function (scope, element, attr) {
                var input = this._findDomTag(element);
                var self = this;
                var attrs = attr;
                _.forOwn(attrs, function (value, key) {
                    if (key[0] === '$') {
                        return;
                    }
                    if (
                        key !== 'class' &&
                        key !== 'label' &&
                        key !== 'ng-class' &&
                        key !== 'ngClass' &&
                        key !== 'ng-model'  &&
                        key !== 'ngModel'  &&
                        key !== 'inputModel'  &&
                        key !== 'choices'  &&
                        key !== 'required' &&
                        key !== 'ng-required' &&
                        key !== 'ngRequired' &&
                        key !== 'ngDisabled'
                    ) {
                        input.attr(key, value);
                    }
                    if (key === 'required') {
                        element.addClass('required', true);
                        input.prop('required', true);
                    }
                    if (key === 'name') {
                        scope.name = value;
                    }
                    self.watchIdToInput(scope, input);
                });
                this.setNameAttrFromNgModel(scope, element, attr);

            },

            falseTelProxyFormatter: function (value) {
                if (value === false) {
                    return '';
                }
                return value;
            },
            /**
             * openerp orm return false value for empty attributes.
             * This controller add a proxy on the scope so we can handle this
             */
            falseProxyFormatter: function (value) {
                if (value === false) {
                    return undefined;
                }
                return value;
            },
            falseProxyParser: function (viewValue) {
                if (viewValue === undefined || viewValue === '' || viewValue === null) {
                    return false;
                }
                return viewValue;
            },
            wrapNgModelWithOnchange: function (scope, ngModel) {
                ngModel.$viewChangeListeners.push(function () {
                    if (scope.swifChange) {
                        var vals = {};
                        if (scope.swifChangeContext) {
                            vals = scope.swifChangeContext();
                        }
                        vals.$value = ngModel.$modelValue;
                        scope.swifChange(vals);
                    }
                });
            },
            wrapNgModelWithProxy: function (scope, ngModel) {
                ngModel.$render = function () {
                    if (scope.proxy !== ngModel.$viewValue) {
                        scope.proxy = ngModel.$viewValue;
                    }
                };
                scope.$watch('proxy', function (newV) {
                    ngModel.$setViewValue(newV);
                });
            },
            falseProxyLink: function (scope, element, attr, ngModel) {
                service.copyAttributesToInput(scope, element, attr);
                service.watchNgRequired(scope, element);
                ngModel.$parsers.push(service.falseProxyParser);
                ngModel.$formatters.push(service.falseProxyFormatter);
                service.wrapNgModelWithProxy(scope, ngModel);
                service.wrapNgModelWithOnchange(scope, ngModel);
                scope.form = scope.$parent.form;
            },
            passwordLink: function (scope, element, attr, ngModel) {
                service.falseProxyLink(scope, element, attr, ngModel);
                scope.passwordType = 'password';
                scope.togglePassword = function () {
                    const type = scope.passwordType;
                    scope.passwordType = type === 'password' ? 'text' : 'password';
                }
            },
            telProxyLink: function (scope, element, attr, ngModel) {
                service.falseProxyLink(scope, element, attr, ngModel);
                // remove the formatter defined in falseProxyLink (the last one on the Array)
                ngModel.$formatters.splice(-1, 1);
                // and add the phone specific formatter
                ngModel.$formatters.push(service.falseTelProxyFormatter);
            },
            wrapNgModelWithProxySelectOne: function (scope, ngModel) {
                scope.proxy = {};
                if (scope.allowClear === null) {
                    scope.allowClear = true;
                }
                ngModel.$render = function () {
                    var model = ngModel.$modelValue;
                    if (!model){
                        scope.proxy = {}; // delete the selected property
                    } else if (model.length === 2) {
                        if (!scope.proxy.selected) {
                            scope.proxy.selected = {
                                id: model[0],
                                name: model[1]
                            };
                        } else if (scope.proxy.selected.id !== model[0]) {
                            scope.proxy.selected = {
                                id: model[0],
                                name: model[1]
                            };
                        }
                    }
                };

                ngModel.$viewChangeListeners.push(function () {
                    if (scope.swifChange) {
                        scope.swifChange({$value: scope.proxy.selected || {}});
                    }
                });
                scope.updateModelFromProxy = function () {
                    var value = scope.proxy.selected;
                    var vv = ngModel.$viewValue;
                    if (value === undefined || value === '' || value === null) {
                        if (vv) {
                            ngModel.$setViewValue(false);
                        }
                    } else {
                        var newModelV = [value.id, value.name];
                        if (ngModel.$viewValue === undefined || ngModel.$viewValue === null || ngModel.$viewValue[0] !== value.id) {
                            ngModel.$setViewValue(newModelV);
                        }
                    }
                };
                scope.$watch('proxy.selected', function (newValue, oldValue) {
                    //check if old === new
                    if (oldValue && newValue) {
                        if (oldValue.id === newValue.id){
                            return;
                        }
                    }
                    scope.updateModelFromProxy();
                });
            },
            addOpenBoolean: function (scope, element, attr) {
                if (_.isUndefined(attr)) {
                    attr = 'opened';
                }
                scope[attr] = false;
                scope.open = function (attr) {
                    if (_.isUndefined(attr)) {
                        attr = 'opened';
                    }
                    scope[attr] = true;
                };
                scope.close = function (attr) {
                    if (_.isUndefined(attr)) {
                        attr = 'opened';
                    }
                    scope[attr] = false;
                };
                scope.toggle = function ($event, attr) {
                    if (_.isUndefined(attr)) {
                        attr = 'opened';
                    }
                    scope[attr] = !scope[attr];
                    if ($event && scope[attr]) {
                        $($event.target).parents('.input-group').children('input').focus();
                    }
                };
                $('html').click(function() {
                    if (scope[attr]) {
                        scope.close(attr);
                        scope.$apply();
                    }
                });

                element.on('click', 'table, input, a', function(event){
                    event.stopPropagation();
                });
            },
            uiSelectSupport: function (d, gettextCatalog, dataService, settingsService) {
                /**
                 * Cas d'utilisation :
                 * * select one, select multiple
                 * * required with only one value must fill the value
                 * * if more than 100 values, use refresh(text) to update choices
                 * @type {String}
                 */
                d.scope.choices = '=?';
                d.scope.filter = '=?';
                d.scope.type = '@?';
                d.scope.validationTypeChoices = '@?';
                d.scope.limit = '=?';
                d.scope.onSelectTag = '&?';
                d._link = function (scope, element, attr) {
                    service.copyAttributesToInput(scope, element, attr);
                    scope.form = scope.$parent.form;
                    scope.choices = scope.choices || [];
                    scope._refreshFilter = false;
                    /**
                     * get the filter for the current ui-select
                     * @return {[type]} [description]
                     */
                    scope.uiSelectFilter = function () {
                        var filters = angular.copy(scope.filter) || {};
                        filters.fields = filters.fields || ['id', 'name', 'complete_name', 'is_active'];
                        if (!filters.sort) {
                            var defaultSort = settingsService.getContentType(scope.type).filterSort;
                            if (defaultSort) {
                                dataService.sortOnRaw(filters, defaultSort);
                            } else {
                                dataService.sortOn(filters, 'name');
                            }
                        }
                        // can overwrite the search_read limit to the chosen one
                        filters.limit = _.isUndefined(scope.limit) ? 100 : scope.limit;
                        return filters;
                    };

                    /**
                     * loadChoices
                     * @param  {[type]} force [description]
                     * @return {[type]}       [description]
                     */
                    var loadChoices = function (force) {
                        if (!scope.type) {
                            return;
                        }
                        var _loadChoices = function (filters) {
                            dataService.searchRead(scope.type, filters)
                            .then(function(data) {
                                // if an element is clearly unactive, we filtered it
                                scope.choices = data.records.filter(choice => choice.is_active === undefined || choice.is_active || choice.active);
                                //detect more than 100 results
                                if (!scope._refreshFilter && data.length > 100) {
                                    scope._refreshFilter = true;
                                }
                            });
                        };
                        var filter = scope.uiSelectFilter();
                        if (scope.textFilter && scope._refreshFilter) {
                            dataService.addTextExtraFilter(
                                filter, scope.type, scope.textFilter
                            ).then(function (filter) {
                                _loadChoices(filter);
                            });
                        } else if (scope._refreshFilter) {
                            _loadChoices(filter);
                        } else if (force) {
                            _loadChoices(filter);
                        }
                    };
                    scope.shouldDisableChoice = function (item) {
                        if(!scope.validationTypeChoices) {
                            return;
                        }
                        if ((!swifModule.regex[scope.validationTypeChoices].test(item[scope.validationTypeChoices])) ){
                            return true;
                        }
                    };
                    scope.refresh = function (text) {
                        scope.textFilter = text;
                        //we start looking for choices when user write more than one character
                        if (text.length > 1){
                            loadChoices();
                        }
                    };

                    if (attr.translateChoices !== undefined) {
                        for (var i = 0; i < scope.choices.length; i++) {
                            scope.choices[i].name = gettextCatalog.getString(scope.choices[i].name);
                        }
                    }

                    scope.$on('angular.ui.select.activate', function () {
                        loadChoices(true);
                    });
                };
            },
            getSelectOneDefinition: function (gettextCatalog, dataService, settingsService) {
                var d = angular.copy(service.DEFAULT_WIDGET_DIRECTIVE);
                d.scope.forceInit = '=?';
                this.uiSelectSupport(d, gettextCatalog, dataService, settingsService);
                d.link = function (scope, element, attr, ngModel) {
                    d._link(scope, element, attr, ngModel);

                    ngModel.$parsers.push(service.falseProxyParser);
                    ngModel.$formatters.push(service.falseProxyFormatter);

                    scope.resetSearchInput = scope.barcodeMode ? true : false;
                    scope.closeOnSelect = scope.barcodeMode ? false : true;
                    scope.maxResults = parseInt(scope.limitResults, 10);

                    service.wrapNgModelWithProxySelectOne(scope, ngModel);

                    // if element is required and the current filter returns only 1 element,
                    // set this element automatically
                    var autoSetValue = function () {
                        if(scope.ngRequired && !scope.proxy.selected && scope.type) {
                            var filter = angular.copy(scope.filter || {});
                            filter.limit = 2;
                            filter.fields = filter.fields || ['id', 'name', 'complete_name'];
                            if (filter.sort === undefined) {
                                var defaultSort = settingsService.getContentType(scope.type).filterSort;
                                if (defaultSort) {
                                    dataService.sortOnRaw(filter, defaultSort);
                                } else {
                                    dataService.sortOn(filter, 'name');
                                }
                            }
                            dataService.searchRead(scope.type, filter)
                            .then(function (data) {
                                if(data.length === 1 || scope.forceInit && data.length > 0) {
                                    scope.proxy.selected = data.records[0];
                                }
                            });
                        }
                    };

                    scope.$watch('filter.domain', function () {
                        // if in 'fetch-mode' and if a data was already set before changing the filter,
                        // perform a get (id, name) to verify the value is always available via the filter
                        if(scope.type && scope.proxy.selected && scope.filter && scope.filter.domain) {
                            var tempFilter = angular.copy(scope.filter);
                            tempFilter.domain.push(['id', '=', scope.proxy.selected.id]);
                            tempFilter.fields = tempFilter.fields || ['id', 'name'];
                            dataService.searchRead(scope.type, tempFilter)
                            .then(function (data) {
                                if(data.length === 0) {
                                    scope.proxy = {};
                                    autoSetValue();
                                }
                            });
                        } else if(scope.type && !scope.proxy.selected) {
                            autoSetValue();
                        }
                    }, true);

                    // call autoSaveValue() once the directive is initialized

                    // if scope.type is changed, we have to adapt the ui-select
                    scope.$watch('type', function (newV) {
                        if (newV) {
                            autoSetValue();
                        }
                    });

                    scope.$watch('defaultSelected', function (newV) {
                        if (newV) {
                            scope.proxy.selected = newV;
                        }
                    });

                    scope.$watch('$parent.defaultSelected', function (newV) {
                        if (newV) {
                            scope.proxy.selected = newV;
                        }
                    });
                };
                return d;

            },

            getSelectMultipleDefinition: function (gettextCatalog, dataService, settingsService) {
                var d = angular.copy(service.DEFAULT_WIDGET_DIRECTIVE);
                this.uiSelectSupport(d, gettextCatalog, dataService, settingsService);
                d.link = function (scope, element, attr, ngModel) {
                    d._link(scope, element, attr, ngModel);
                    scope.proxy = {};
                    ngModel.$render = function () {
                        scope.proxy.selected = ngModel.$viewValue;
                    };
                    scope.emptyValue = function () {
                        scope.proxy.selected = [];
                    };
                    // Optional attribut to pass selected tag value to parent directive
                    if(scope.onSelectTag) {
                        scope.onSelect = function (item, model) {
                            scope.onSelectTag({ item: item });
                        };
                    }
                    var addToChoices = function (selected_ids) {
                        var ids = [];
                        _.forEach(scope.choices, function (choice) {
                            if (_.contains(selected_ids, choice.id)) {
                                ids.push(choice.id);
                            }
                        });
                        var load_ids = _.difference(selected_ids, ids);
                        if (!_.isEmpty(load_ids)) {
                            var filter = scope.uiSelectFilter();
                            filter.fields = filter.fields || ['id', 'name', 'complete_name'];
                            dataService.addFilter(filter, 'id', 'in', load_ids);
                            dataService.searchRead(scope.type, filter)
                            .then(function (data) {
                                scope.choices = _.union(scope.choices, data.records);
                            });
                        }
                    };
                    scope.$watch('proxy.selected', function (newV) {
                        if (_.isArray(newV) && _.isEmpty(newV)) {
                            //should we keep empty list / undefined / false ?
                            ngModel.$setViewValue();
                        } else {
                            ngModel.$setViewValue(newV);
                            if (scope.type) {
                                addToChoices(newV);
                            }
                        }
                    }, true);
                    scope.$watch('filter.domain', function () {
                        // if in 'fetch-mode' and if a data was already set before changing the filter,
                        // perform a get (id, name) to verify the value is always available via the filter
                        if(scope.type && scope.proxy.selected &&
                            scope.proxy.selected.length > 0 &&
                            scope.filter && scope.filter.domain &&
                            scope.filter.domain.length > 0
                        ) {
                            var tempFilter = angular.copy(scope.filter);
                            tempFilter.domain.push(['id', 'in', scope.proxy.selected]);
                            tempFilter.fields = tempFilter.fields || ['id', 'name', 'complete_name'];
                            dataService.get(scope.type, undefined, tempFilter)
                            .then(function (data) {
                                if(data.length === 0) {
                                    scope.proxy = {};
                                }
                            });
                        }
                    }, true);

                    // if scope.type is changed, we have to adapt the ui-select
                    scope.$watch('type', function (newV) {
                        if (newV) {
                            ngModel.$render();
                        }
                    });

                };
                return d;
            },

            // sometimes, scope.form is not initialized when ngModel changes,
            // so i put a timeout() which call itself until it successfully
            // set $dirty to the component
            addDateDirty: function (scope) {
                if (scope.form && scope.name) {
                    if (scope.form[scope.name]){
                        scope.form[scope.name].$setDirty();
                    }
                } else {
                    $timeout(function () {
                        service.addDateDirty(scope);
                    }, 1000);
                }
            },

            addDateSupport: function (scope, element, attr, ngModel) {
                var modelFormat = 'YYYY-MM-DD';
                var outputFormat = 'DD-MM-YYYY';
//                scope.placeholder = moment().format(outputFormat);
                scope.placeholder = 'JJ-MM-AAAA';
                scope.outputFormat = outputFormat;
                scope.datepickerOptions = {
                    showWeeks: true,
                    startingDay: 1,
                    dateDisabled: scope.customDateDisabled || undefined
                };
                scope.today = function () {
                    scope.proxyString = moment().format(outputFormat);
                };
                var formatter = function (value) {
                    if (value) {
                        return swifMomentUtility.formatDate(value, modelFormat);
                    }
                };
                ngModel.$formatters.push(formatter);
                var parser = function (value) {
                    if (value === 'Invalid date') {
                        return false;
                    }
                    return value;
                };
                ngModel.$parsers.push(parser);

                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    //console.log('$render -> ' + vv);
                    if (!_.isEmpty(vv)) {
                        var nProxyString = swifMomentUtility.formatDate(vv, outputFormat);
                        if (scope.proxyString !== nProxyString) {
                            //console.log('update proxyString');
                            scope.proxyString = nProxyString;
                        }
                        var nProxy = new Date(vv);
                        if (!_.isEqual(scope.proxy, nProxy)) {
                            //console.log('update proxy');
                            scope.proxy = nProxy;
                        }
                    } else {
                        if (scope.proxyString !== undefined) {
                            //console.log('delete proxyString');
                            scope.proxyString = undefined;
                        }
                        if (scope.proxy !== undefined) {
                            //console.log('delete proxy');
                            scope.proxy = undefined;
                        }
                    }
                };
                scope.$watch('minDate', function (newValue, oldValue) {
                    if (newValue) {
                        scope.datepickerOptions.minDate = new Date(newValue);
                    }
                });
                scope.$watch('proxyString', function (newValue, oldValue) {
                    //input text -> model
                    //input text -> date picker

                    // as the widget is usable without any keyboard input,
                    // we have to set the $dirty manually (to trigger ng validations)
                    // var dirty = oldValue && !angular.equals(newValue, oldValue);
                    var dirty = Boolean(newValue);
                    // @TOCHECK: sometimes, this watcher is triggered before scope.form
                    // has a value (undefined), i added a check on scope.form, but check
                    // if there is a better way to handle that
                    if (dirty) {
                        service.addDateDirty(scope);
                    }

                    if (newValue === oldValue) {
                        return;
                    }
                    var vv = ngModel.$viewValue;
                    if (_.isEmpty(newValue) && !_.isEmpty(vv)) {
                        ngModel.$setViewValue(false);
                        scope.proxy = false;
                    } else if (!_.isEmpty(newValue)){
                        var m = moment(newValue, outputFormat);
                        var newModel = m.format(modelFormat);
                        if (vv !== newModel) {
                            //console.log('update ngModel');
                            ngModel.$setViewValue(newModel);
                        }
                        var newDate = m.toDate();
                        if (!angular.equals(newDate, scope.proxy)) {
                            scope.proxy = newDate;
                        }
                    }
                });
                scope.$watch('proxy', function (newValue) {
                    //date picker -> input text
                    if (newValue) {
                        var m = moment(newValue);
                        var newProxyString = m.format(outputFormat);
                        if (scope.proxyString !== newProxyString) {
                            scope.proxyString = newProxyString;
                            scope.opened = false;
                            scope.specialday = swifMomentUtility.get_specialday(m);
                            scope.is_specialday = scope.specialday !== undefined && scope.displaySpecialDay !== false;
                        }
                    }
                });
            },
            addDatetimeSupport: function (scope, element, attr, ngModel) {
                var modelFormat = 'YYYY-MM-DD HH:mm:00';
                var outputFormat = 'DD-MM-YYYY';
                var inputFormat = 'DD-MM-YYYY HH:mm';
//                scope.placeholder = moment().format(outputFormat);
                scope.placeholder = 'JJ-MM-AAAA';
                scope.datepicker = {};
                scope.datepickerOptions = {
                    showWeeks: true,
                    startingDay: 1
                };
                var formatter = function (value) {
                    if (value) {
                        return swifMomentUtility.formatDatetime(value, modelFormat);
                    }
                };
                ngModel.$formatters.push(formatter);
                var parser = function (value) {
                    if (value === 'Invalid date') {
                        return false;
                    }
                    return value;
                };
                scope.today = function () {
                    scope.dateString = moment().format(outputFormat);
                };
                ngModel.$parsers.push(parser);
                scope.is_specialday = false;

                ngModel.$render = function () {
                    scope.view = {};
                    var vv = ngModel.$viewValue;
                    if (vv === false || vv === undefined) {
                        if (scope.datepicker.date !== undefined) {
                            scope.datepicker.date = undefined;
                        }
                        if (scope.dateString !== undefined) {
                            scope.dateString = undefined;
                        }
                        if (scope.timeString !== undefined) {
                            scope.timeString = undefined;
                        }
                    } else {
                        var date = swifMomentUtility.getMomentDatetime(vv);
                        var newDateDate = date.toDate();
                        var dt = moment.tz(vv, modelFormat, swifMomentUtility.getTimeZone());
                        // var newDateString = swifMomentUtility.formatDate(date, outputFormat);
                        // var newTimeString = swifMomentUtility.formatDate(date, 'HH:mm');
                        var newDateString = dt.format(outputFormat);
                        var newTimeString = dt.format('HH:mm');
                        if (!angular.equals(scope.datepicker.date, newDateDate)) {
                            scope.datepicker.date = newDateDate;
                        }
                        if (scope.dateString !== newDateString) {
                            scope.dateString = newDateString;
                        }
                        if (scope.timeString !== newTimeString) {
                            scope.timeString = newTimeString;
                        }
                        // finally, re-initialize internal proxy to UTC value
                        /*var newDt = dt.utc().format('YYYY-MM-DD HH:mm:00');
                        ngModel.$setViewValue(newDt);*/
                    }
                };
                var validateDateString = function (d) {
                    var isValid = !_.isUndefined(d);
                    isValid = isValid && _.size(d) === 10;
                    return isValid;
                };
                var validateTimeString = function (d) {
                    var isValid = !_.isUndefined(d);
                    isValid = isValid && _.size(d) === 5;
                    return isValid;
                };
                scope.setTimeString = function (timeString) {
                    scope.timeString = timeString;
                    scope.timeOpened = false;
                };
                scope.scrolled = false;
                scope.$watch('timeOpened', function (newV) {
                    if (newV && !scope.scrolled) {
                        scope.scrolled = true;
                        //scroll to timeString || 8:00
                        var dd = element.find('.dropdown-menu-hour');
                        var target = scope.timeString ? scope.timeString.split(':')[0] + ':00' : '08:00';
                        var index = scope.hours.indexOf(target);
                        var btn = element.find('.btn-hour-'+index);
                        if (btn) {
                            setTimeout(function () {
                                if (btn) {
                                    dd.scrollTop(btn.position().top);
                                }
                            }, 100);
                        }
                    }
                });
                scope.$watchGroup(['dateString', 'timeString'], function (nValues, oValues) {
                    // as the widget is usable without any keyboard input,
                    // we have to set the $dirty manually (to trigger ng validations)
                    // var dirty = oldValue && !angular.equals(newValue, oldValue);
                    var dirty = Boolean(nValues[0]) || Boolean(nValues[1]);
                    // @TOCHECK: sometimes, this watcher is triggered before scope.form
                    // has a value (undefined), i added a check on scope.form, but check
                    // if there is a better way to handle that
                    if (dirty) {
                        service.addDateDirty(scope);
                    }
                    if (validateDateString(nValues[0])) {
                        var mt = moment(nValues[0], outputFormat);
                        var newDate = angular.copy(mt.toDate());
                        if (!angular.equals(scope.datepicker.date, newDate)) {
                            scope.datepicker.date = newDate;
                            scope.opened = false;
                        }
                        scope.specialday = swifMomentUtility.get_specialday(mt);
                        scope.is_specialday = scope.specialday !== undefined && scope.displaySpecialDay !== false;
                    }
                    if (!validateDateString(nValues[0]) || !validateTimeString(nValues[1])) {
                        ngModel.$setViewValue();
                        return;
                    }
                    scope.timeOpened = false;
                    if (angular.equals(nValues, oValues)) {
                        return;
                    }
                    var vv = ngModel.$viewValue;
                    var newValue = nValues[0] + ' ' + nValues[1];
                    var m = moment.tz(newValue, inputFormat, swifMomentUtility.getTimeZone());
                    var newModel = m.utc().format('YYYY-MM-DD HH:mm:00');
                    // Fix TG3486 - Only for task and inter, appliying this change for every field
                    // will lead to back errors du to date format (in reservation for example)
                    if (Object.keys(ngModel.$$parentForm).includes("model.date_start")){
                        ngModel.$setViewValue(m);
                    }
                    else if (!angular.equals(vv, newModel)) {
                        ngModel.$setViewValue(newModel);
                    }
                });
                scope.$watch('datepicker.date', function (newValue, oldValue) {
                    if (newValue === undefined) {
                        return;
                    } else if (oldValue && newValue) {
                        if (newValue.toString() === oldValue.toString()) {
                            return;
                        }
                        if (newValue.length < 10) {
                            return;
                        }
                    }
                    if (newValue === '' || newValue === undefined || newValue === null) {
                        if (scope.dateString !== undefined) {
                            delete scope.dateString;
                        }
                    } else {
                        var newDateString = moment(newValue).format(outputFormat);
                        if (scope.dateString !== newDateString) {
                            scope.dateString = newDateString;
                            scope.opened = false;
                        }
                    }
                });
/*                scope.$watch('dateString', function (newValue, oldValue) {
                    // as the widget is usable without any keyboard input,
                    // we have to set the $dirty manually (to trigger ng validations)
                    // var dirty = oldValue && !angular.equals(newValue, oldValue);
                    var dirty = Boolean(newValue);
                    // @TOCHECK: sometimes, this watcher is triggered before scope.form
                    // has a value (undefined), i added a check on scope.form, but check
                    // if there is a better way to handle that
                    if (dirty) {
                        service.addDateDirty(scope);
                    }

                    if (newValue === oldValue) {
                        return;
                    }
                    if (newValue === '' || newValue === undefined || newValue === null) {
                        if (scope.dateDate !== undefined) {
                            scope.dateDate = undefined;
                        }
                    } else {
                        var vv = ngModel.$viewValue;
                        var m = moment(newValue, outputFormat);
                        var newDate = m.toDate();
                        if (!_.isEqual(scope.proxy, newDate)) {
                            scope.dateDate = newDate;
                        }
                        var newModel = swifMomentUtility.parseDatetime(m);
                        if (vv !== newModel) {
                            ngModel.$setViewValue(newModel);
                        }
                    }
                });*/
            },

            datetimeDirective: function (d) {
                var self = this;
                d.scope.minDatetime = '=?';
                d.scope.maxDatetime = '=?';
                d.scope.displaySpecialDay = '=?';
                d.link = function (scope, element, attr, ngModel) {
                    self.copyAttributesToInput(scope, element, attr);
                    self.watchNgRequired(scope, element);
                    //swifFormUtility.wrapNgModelWithProxy(scope, ngModel);
                    self.addOpenBoolean(scope, element);
                    self.addOpenBoolean(scope, element, 'timeOpened');
                    self.addDatetimeSupport(scope, element, attr, ngModel);
                    self.addMinDatetimeSupport(scope, element, attr, ngModel);
                    self.addMaxDatetimeSupport(scope, element, attr, ngModel);
                    scope.form = scope.$parent.form;
                    scope.hours = [
                        '00:00',
                        '00:30',
                        '01:00',
                        '01:30',
                        '02:00',
                        '02:30',
                        '03:00',
                        '03:30',
                        '04:00',
                        '04:30',
                        '05:00',
                        '05:30',
                        '06:00',
                        '06:30',
                        '07:00',
                        '07:30',
                        '08:00',
                        '08:30',
                        '09:00',
                        '09:30',
                        '10:00',
                        '10:30',
                        '11:00',
                        '11:30',
                        '12:00',
                        '12:30',
                        '13:00',
                        '13:30',
                        '14:00',
                        '14:30',
                        '15:00',
                        '15:30',
                        '16:00',
                        '16:30',
                        '17:00',
                        '17:30',
                        '18:00',
                        '18:30',
                        '19:00',
                        '19:30',
                        '20:00',
                        '20:30',
                        '21:00',
                        '21:30',
                        '22:00',
                        '22:30',
                        '23:00',
                        '23:30'
                    ];
                };
                return d;
            },

            addMinDateSupport: function (scope, element ,attr, ngModel) {
                // Tests to handle min-date, max-date on directive
                var outputFormat = 'YYYY-MM-DD';
                ngModel.$validators.minDate = function (modelV, vv) {
                    // by default, an empty is always valid for minDate validation
                    if (vv && scope.minDate) {
                        var proxy = moment(vv, outputFormat);
                        proxy = swifMomentUtility.getMomentDate(proxy);
                        var min = swifMomentUtility.getMomentDate(scope.minDate);
                        var ret = min.isBefore(proxy) || min.isSame(proxy);
                        return ret;
                    } else {
                        return true;
                    }
                };
                scope.$watch('minDate', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        ngModel.$validate();
                    }
                });
            },

            addMaxDateSupport: function (scope, element ,attr, ngModel) {
                // Tests to handle min-date, max-date on directive
                var outputFormat = 'YYYY-MM-DD';
                ngModel.$validators.maxDate = function (modelV, vv) {
                    // by default, an empty is always valid for minDate validation
                    if (vv && scope.maxDate) {
                        var proxy = moment(vv, outputFormat);
                        proxy = swifMomentUtility.getMomentDate(proxy);
                        var max = swifMomentUtility.getMomentDate(scope.maxDate);
                        var ret = max.isAfter(proxy) || max.isSame(proxy);
                        return ret;
                    } else {
                        return true;
                    }
                };
                scope.$watch('maxDate', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        ngModel.$validate();
                    }
                });
            },

            addMinDatetimeSupport: function (scope, element ,attr, ngModel) {
                // Tests to handle min-date, max-date on directive
                var outputFormat = 'YYYY-MM-DD HH:mm';
                ngModel.$validators.minDatetime = function (modelV, vv) {
                    // by default, an empty is always valid for minDate validation
                    if (vv && scope.minDatetime) {
                        var proxy = moment(vv, outputFormat);
                        proxy = swifMomentUtility.getMomentDatetime(proxy);
                        var min = swifMomentUtility.getMomentDatetime(scope.minDatetime);
                        var ret = min.isBefore(proxy) || min.isSame(proxy);
                        return ret;
                    } else {
                        return true;
                    }
                };
                scope.$watch('minDatetime', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        ngModel.$validate();
                    }
                });
            },

            addMaxDatetimeSupport: function (scope, element ,attr, ngModel) {
                // Tests to handle min-date, max-date on directive
                var outputFormat = 'YYYY-MM-DD HH:mm';
                ngModel.$validators.maxDatetime = function (modelV, vv) {
                    // by default, an empty is always valid for minDate validation
                    // @TOCHECK: strangely, vv and modelV are unequal at first init of max-datetime
                    // modelV is UTC value, vv is timezone value
                    if (modelV && scope.maxDatetime) {
                        var proxy = moment(modelV, outputFormat);
                        proxy = swifMomentUtility.getMomentDatetime(proxy);
                        var max = swifMomentUtility.getMomentDatetime(scope.maxDatetime);
                        var ret = max.isAfter(proxy) || max.isSame(proxy);
                        return ret;
                    } else {
                        return true;
                    }
                };
                scope.$watch('maxDatetime', function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        ngModel.$validate();
                    }
                });
            },

            addTimeSupport: function (scope, element, attr, ngModel) {
                var initProxy = function () {
                    if (scope.proxy === undefined || scope.proxy === null) {
                        scope.proxy = new Date(1970, 0, 1);
                    }
                    scope.proxy.setMilliseconds(0);
                    scope.proxy.setSeconds(0);
                };
                initProxy();
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    //console.log('setProxyFromModel');
                    if (scope.proxy === undefined || scope.proxy === null) {
                        initProxy();
                    }
                    if (vv !== undefined) {
                        var mo = moment.duration({hours: vv});
                        var h = mo.hours();
                        var m = mo.minutes();
                        if (scope.proxy.getHours() !== h) {
                            scope.proxy.setHours(h);
                        }
                        if (scope.proxy.getMinutes() !== m) {
                            scope.proxy.setMinutes(m);
                        }
                    } else {
    /*                    if (scope.proxy.getHours() !== 0){
                            scope.proxy.setHours(0);
                        }
                        if (scope.proxy.getMinutes() !== 0) {
                            scope.proxy.setMinutes(0);
                        }*/
                        scope.proxy = null;
                    }
                };
                var setModelFromProxy = function () {
                    var vv = ngModel.$viewValue;
                    if (scope.proxy !== undefined && scope.proxy !== null) {
                        scope.proxy.setMilliseconds(0);
                        scope.proxy.setSeconds(0);
                        var d = moment.duration({
                            hours: scope.proxy.getHours(),
                            minutes: scope.proxy.getMinutes()
                        });
                        var f = d.asHours();
                        if (vv !== f) {
                            ngModel.$setViewValue(f);
                        }
                    } else {
                        if (vv !== undefined) {
                            ngModel.$setViewValue(false);
                        }
                    }
                };
                scope.$watch('proxy', function () {
                    setModelFromProxy();
                }, true);
            },
            checkboxDirective: function () {
                var self = this;
                var d = angular.copy(self.DEFAULT_WIDGET_DIRECTIVE);
                d.link = function (scope, element, attr, ngModel) {
                    self.watchNgRequired(scope, element);
                    self.wrapNgModelWithOnchange(scope, ngModel);
                    ngModel.$render = function () {
                        scope.proxy = ngModel.$viewValue;
                    };
                    scope.$watch('proxy', function (newv) {
                        var vv = ngModel.$viewValue;
                        if (newv !== undefined) {
                            if (newv !== vv) {
                                ngModel.$setViewValue(newv);
                            }
                        } else {
                            ngModel.$setViewValue(false);
                        }
                    });
                    scope.toggle = function () {
                        var value = ngModel.$viewValue;
                        if (value !== undefined) {
                            value = !value;
                        } else {
                            value = true;
                        }
                        ngModel.$setViewValue(value);
                        scope.proxy = value;
                    };
                };
                return d;
            },
            revertedCheckboxDirective: function() {
                var self = this;
                var d = angular.copy(self.DEFAULT_WIDGET_DIRECTIVE);
                d.link = function (scope, element, attr, ngModel) {
                    self.watchNgRequired(scope, element);
                    self.wrapNgModelWithOnchange(scope, ngModel);
                    ngModel.$render = function () {
                        scope.proxy = !ngModel.$viewValue;
                    };
                    scope.$watch('proxy', function (newv) {
                        var vv = ngModel.$viewValue;
                        if (newv !== undefined) {
                            ngModel.$setViewValue(!newv);
                        } else {
                            ngModel.$setViewValue(true);
                        }
                    });
                };
                return d;
            }
        };
        return service;
    }




})();
